import { createBrowserHistory } from 'history';

import BasicConfig from '../config/BasicConfig';

export default createBrowserHistory({ basename: BasicConfig.app?.subdirectory || '' });
